(function () {
  "use strict";

  /* =========================================================================
   * Pitstop Pro — Daytona Lifts freight-quote gate
   * -------------------------------------------------------------------------
   * On Daytona Lifts product pages, when the customer chooses "Delivery" in the
   * Globo "Delivery Options" control, an inline freight-quote form appears and
   * the Add to Cart button is blocked until the customer either:
   *    (a) submits the freight-quote form (emailed to the team), OR
   *    (b) ticks "order now, quote after purchase".
   * Submits silently in the background to Shopify's contact form (emails the
   * store contact email) and stays on the page.
   *
   * REQUIRES: "Enable Google reCAPTCHA on the contact form" turned OFF in
   * Settings > Checkout and accounts > Spam protection (otherwise Shopify
   * rejects background contact posts with "Missing CAPTCHA token").
   * ========================================================================= */

  var CFG = {
    VENDOR: "Daytona Lifts",              // only run on this vendor's products
    DELIVERY_FIELD_NAME: "Delivery Options",
    PICKUP_RE: /pick\s*-?\s*up/i,         // matches "Free Warehouse Pickup"
    ATC_SELECTORS: [".product-form--atc-button", 'form[action*="/cart/add"] [name="add"]', '[name="add"]'],
    PHONE_DISPLAY: "(470) 208-2754",
    PHONE_TEL: "4702082754",
    SCROLL_OFFSET: 90,
    BRAND: "#00A1CF",
    BRAND_DARK: "#008DB7"
  };

  /* ---------- tiny helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clean(v) { return ("" + (v == null ? "" : v)).replace(/\s+/g, " ").trim(); }
  var ROOT = (window.Shopify && window.Shopify.routes && (window.Shopify.routes.root || window.Shopify.routes.root_url)) || "/";

  var _product = null, _submitted = false;

  /* ---------- Globo delivery-radio access ---------- */
  function deliveryRadios() {
    return $all('input[type="radio"]').filter(function (r) {
      return new RegExp(CFG.DELIVERY_FIELD_NAME.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i").test(r.name || "");
    });
  }
  function deliveryRadio() {
    return deliveryRadios().filter(function (r) { return !CFG.PICKUP_RE.test(r.value || ""); })[0] || null;
  }
  function isDeliverySelected() {
    var d = deliveryRadio();
    return !!(d && d.checked);
  }
  function deliveryField() {
    var r = deliveryRadios()[0];
    return r ? (r.closest(".gpo-element") || r.closest(".gpo-group")) : null;
  }
  function atcButton() {
    for (var i = 0; i < CFG.ATC_SELECTORS.length; i++) {
      var el = $(CFG.ATC_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  // Make Globo's "Delivery Options" buttons (Pickup / Delivery) the same width.
  function equalizeDelivery() {
    var radios = deliveryRadios();
    if (radios.length < 2) return;
    var labels = radios.map(function (r) {
      var it = r.closest(".gpo-ov-item") || r.parentElement;
      return it && it.querySelector("label");
    }).filter(Boolean);
    labels = labels.filter(function (v, i) { return labels.indexOf(v) === i; });
    if (labels.length < 2) return;
    var field = deliveryField();
    if (field && field.getAttribute("data-dtf-eq") === "1") return;   // already done
    labels.forEach(function (l) {
      l.style.width = ""; l.style.boxSizing = "border-box"; l.style.textAlign = "center";
      if (getComputedStyle(l).display === "inline") l.style.display = "inline-block";
    });
    var max = 0;
    labels.forEach(function (l) { var w = Math.ceil(l.getBoundingClientRect().width); if (w > max) max = w; });
    if (max > 0) {
      labels.forEach(function (l) { l.style.width = max + "px"; });
      if (field) field.setAttribute("data-dtf-eq", "1");
    }
  }

  // Stretch the card's right edge to line up with the Add to Cart button.
  function fitWidth(wrap) {
    var atc = atcButton();
    if (!atc || !wrap || !wrap.parentNode) return;
    wrap.style.width = "";
    var a = atc.getBoundingClientRect(), w = wrap.getBoundingClientRect();
    if (!a.width || !w.width) return;
    var extra = Math.round(a.right - w.right);
    if (extra > 2) wrap.style.width = Math.round(w.width + extra) + "px";
  }

  /* ---------- gate state ---------- */
  function orderNowChecked() { var c = $("#dtf-ordernow"); return !!(c && c.checked); }
  function gateSatisfied() { return _submitted || orderNowChecked(); }
  function shouldGate() { return isDeliverySelected() && !gateSatisfied(); }

  function applyGate() {
    var atc = atcButton();
    if (!atc) return;
    if (shouldGate()) { atc.classList.add("dtf-blocked"); atc.setAttribute("aria-disabled", "true"); }
    else { atc.classList.remove("dtf-blocked"); atc.removeAttribute("aria-disabled"); }
  }

  // Capture-phase interceptor: check state at click time (never leaves ATC permanently dead)
  function interceptATC(e) {
    var atc = atcButton();
    if (!atc) return;
    var target = e.target.closest ? e.target.closest(CFG.ATC_SELECTORS.join(",")) : null;
    if (!target) return;
    if (shouldGate()) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var card = $(".dtf-card");
      if (card) {
        var y = card.getBoundingClientRect().top + window.pageYOffset - CFG.SCROLL_OFFSET;
        window.scrollTo({ top: y, behavior: "smooth" });
        card.classList.remove("dtf-flash"); void card.offsetWidth; card.classList.add("dtf-flash");
      }
    }
  }

  /* ---------- CSS ---------- */
  var CSS = '' +
    '.dtf-wrap{margin:12px 0 14px;font-family:inherit}' +
    '.dtf-card{border:1px solid #dfe4e8;border-radius:12px;overflow:hidden;background:#fff;box-shadow:0 1px 2px rgba(16,24,40,.04)}' +
    '.dtf-flash{animation:dtfFlash 1s ease}' +
    '@keyframes dtfFlash{0%,100%{box-shadow:0 0 0 0 rgba(0,161,207,0)}30%{box-shadow:0 0 0 4px rgba(0,161,207,.4)}}' +
    '.dtf-head{background:' + CFG.BRAND + ';color:#fff;padding:13px 16px;display:flex;align-items:center;gap:10px}' +
    '.dtf-head svg{width:22px;height:22px;flex:0 0 auto}' +
    '.dtf-head b{display:block;font-size:15.5px;font-weight:800;line-height:1.2}' +
    '.dtf-head span{display:block;font-size:12px;opacity:.92;margin-top:1px}' +
    '.dtf-body{padding:14px 16px 16px}' +
    '.dtf-step{border-top:1px solid #eef1f3;padding:13px 0 4px}.dtf-step:first-child{border-top:0;padding-top:2px}' +
    '.dtf-steptitle{display:flex;align-items:center;gap:8px;font-size:13px;font-weight:800;color:#0f2430;text-transform:uppercase;letter-spacing:.03em;margin:0 0 10px}' +
    '.dtf-num{flex:0 0 auto;width:20px;height:20px;border-radius:50%;background:' + CFG.BRAND + ';color:#fff;font-size:12px;font-weight:800;display:flex;align-items:center;justify-content:center}' +
    '.dtf-lbl{display:block;font-size:12.5px;font-weight:700;color:#33414b;margin:0 0 5px}' +
    '.dtf-row{display:flex;gap:10px;margin-bottom:10px}.dtf-row>div{flex:1;min-width:0}.dtf-row:last-child{margin-bottom:0}' +
    '.dtf-in{width:100%;box-sizing:border-box;padding:11px 12px;border:1px solid #cbd2d8;border-radius:9px;font-size:15px;background:#fff}' +
    '.dtf-in:focus{outline:none;border-color:' + CFG.BRAND + ';box-shadow:0 0 0 3px rgba(0,161,207,.15)}' +
    '.dtf-seg{display:flex;gap:8px}.dtf-seg.dtf-2 .dtf-pill{flex:1}' +
    '.dtf-pill{flex:0 1 auto;padding:11px 14px;border:1.5px solid #cbd2d8;border-radius:9px;background:#fff;color:#33414b;font-size:14px;font-weight:600;cursor:pointer;text-align:center;transition:all .12s ease;box-sizing:border-box}' +
    '.dtf-pill:hover{border-color:' + CFG.BRAND + '}' +
    '.dtf-pill.dtf-on{background:' + CFG.BRAND + ';border-color:' + CFG.BRAND + ';color:#fff;box-shadow:0 1px 4px rgba(0,161,207,.35)}' +
    '.dtf-mini{font-size:12.5px;font-weight:700;color:#33414b;margin:0 0 6px}' +
    '.dtf-cta{width:100%;box-sizing:border-box;margin-top:14px;padding:14px 16px;border:0;border-radius:10px;background:' + CFG.BRAND + ';color:#fff;font-weight:800;font-size:15.5px;cursor:pointer;transition:background .12s ease}' +
    '.dtf-cta:hover{background:' + CFG.BRAND_DARK + '}.dtf-cta:disabled{opacity:.6;cursor:default}' +
    '.dtf-foot{display:flex;gap:8px;align-items:flex-start;margin-top:12px;font-size:12.5px;color:#5b6b75;cursor:pointer;line-height:1.45}' +
    '.dtf-foot input{margin-top:2px;flex:0 0 auto}' +
    '.dtf-callout{font-size:12.5px;color:#33414b;background:#f2fafd;border:1px solid #bfe6f2;border-radius:9px;padding:9px 12px;margin:0 0 4px}' +
    '.dtf-callout a{color:' + CFG.BRAND_DARK + ';font-weight:800;text-decoration:none;white-space:nowrap}' +
    '.dtf-err{color:#b42318;font-size:13px;margin-top:9px}' +
    '.dtf-ok{padding:16px;font-size:14.5px;color:#0f2430;line-height:1.55}.dtf-ok b{color:' + CFG.BRAND_DARK + '}' +
    '.dtf-blocked{opacity:.5;filter:grayscale(.3)}' +
    '@media(max-width:600px){.dtf-row{flex-direction:column;gap:10px}}';

  function injectCSS() {
    if ($("#dtf-style")) return;
    var s = document.createElement("style");
    s.id = "dtf-style"; s.textContent = CSS;
    document.head.appendChild(s);
  }

  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v11H1zM14 7h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';

  function seg(field, opts) {
    var h = '<div class="dtf-seg dtf-2" data-f="' + field + '">';
    opts.forEach(function (o) { h += '<button type="button" class="dtf-pill" data-v="' + o.v + '">' + o.t + '</button>'; });
    return h + '</div>';
  }

  /* ---------- build the form ---------- */
  function formHTML() {
    return '' +
      '<div class="dtf-card">' +
        '<div class="dtf-head">' + TRUCK +
          '<div><b>Get your freight shipping quote</b>' +
          '<span>Daytona lifts ship freight-quoted. We\'ll email your exact cost, usually same day.</span></div>' +
        '</div>' +
        '<div class="dtf-body">' +

          '<div class="dtf-step">' +
            '<div class="dtf-steptitle"><span class="dtf-num">1</span> Where it\'s headed</div>' +
            '<div class="dtf-row">' +
              '<div><label class="dtf-lbl">Delivery ZIP code</label>' +
                '<input class="dtf-in" data-f="zip" type="text" inputmode="numeric" maxlength="5" placeholder="Ships-to ZIP"></div>' +
            '</div>' +
            '<div class="dtf-mini">Address type</div>' +
            seg("loc", [{ v: "Residential", t: "Home / Residential" }, { v: "Commercial", t: "Business / Commercial" }]) +
          '</div>' +

          '<div class="dtf-step">' +
            '<div class="dtf-steptitle"><span class="dtf-num">2</span> Unloading at your site</div>' +
            '<div class="dtf-row">' +
              '<div><div class="dtf-mini">Forklift available?</div>' + seg("forklift", [{ v: "Yes", t: "Yes" }, { v: "No", t: "No" }]) + '</div>' +
              '<div><div class="dtf-mini">Loading dock on site?</div>' + seg("dock", [{ v: "Yes", t: "Yes" }, { v: "No", t: "No" }]) + '</div>' +
            '</div>' +
          '</div>' +

          '<div class="dtf-step">' +
            '<div class="dtf-steptitle"><span class="dtf-num">3</span> Where to send it</div>' +
            '<div class="dtf-row">' +
              '<div><label class="dtf-lbl">First name</label><input class="dtf-in" data-f="first" type="text" placeholder="First name"></div>' +
              '<div><label class="dtf-lbl">Last name</label><input class="dtf-in" data-f="last" type="text" placeholder="Last name"></div>' +
            '</div>' +
            '<div class="dtf-row">' +
              '<div><label class="dtf-lbl">Email</label><input class="dtf-in" data-f="email" type="email" placeholder="you@email.com"></div>' +
              '<div><label class="dtf-lbl">Phone</label><input class="dtf-in" data-f="phone" type="tel" inputmode="tel" placeholder="Best number"></div>' +
            '</div>' +
          '</div>' +

          '<button type="button" class="dtf-cta" id="dtf-submit">Email me my freight quote</button>' +
          '<div class="dtf-err" id="dtf-err" style="display:none"></div>' +
          '<div class="dtf-callout" style="margin-top:12px">Prefer to talk it through? Call us at ' +
            '<a href="tel:' + CFG.PHONE_TEL + '">' + CFG.PHONE_DISPLAY + '</a>.</div>' +
          '<label class="dtf-foot"><input type="checkbox" id="dtf-ordernow">' +
            '<span>I\'d rather order now and get my freight quote after checkout.</span></label>' +
        '</div>' +
      '</div>';
  }

  /* ---------- read values ---------- */
  function segVal(wrap, field) {
    var on = $('.dtf-seg[data-f="' + field + '"] .dtf-on', wrap);
    return on ? on.getAttribute("data-v") : "";
  }
  function collect(wrap) {
    function v(f) { var el = $('input[data-f="' + f + '"]', wrap); return el ? clean(el.value) : ""; }
    return {
      first: v("first"), last: v("last"), phone: v("phone"), zip: v("zip"),
      loc: segVal(wrap, "loc"), forklift: segVal(wrap, "forklift"), dock: segVal(wrap, "dock"),
      email: v("email")
    };
  }

  function validate(d) {
    if (!d.first || !d.last) return "Please enter your first and last name.";
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.email)) return "Please enter a valid email address.";
    if (!/^\+?[\d\s().-]{7,}$/.test(d.phone)) return "Please enter a valid phone number.";
    if (!/^\d{5}$/.test(d.zip)) return "Please enter a valid 5-digit ZIP.";
    if (!d.loc) return "Please choose a home or business address.";
    if (!d.forklift) return "Let us know if a forklift is available.";
    if (!d.dock) return "Let us know if there's a loading dock.";
    return null;
  }

  /* ---------- submit (silent background post to Shopify contact form) ---------- */
  function submitQuote(d, btn, errEl, card) {
    var p = _product || {};
    var body =
      "Freight quote request — Daytona Lifts\n" +
      "Product: " + (p.title || document.title) + "\n" +
      "SKU: " + (p.sku || "") + "\n" +
      "Page: " + location.href + "\n\n" +
      "Name: " + d.first + " " + d.last + "\n" +
      "Email: " + d.email + "\n" +
      "Phone: " + d.phone + "\n" +
      "Ship-to ZIP: " + d.zip + "\n" +
      "Address type: " + d.loc + "\n" +
      "Forklift on site: " + d.forklift + "\n" +
      "Loading dock on site: " + d.dock;

    var form = new URLSearchParams();
    form.append("form_type", "contact");
    form.append("utf8", "✓");
    form.append("contact[email]", d.email);
    form.append("contact[Name]", d.first + " " + d.last);
    form.append("contact[Phone]", d.phone);
    form.append("contact[Ship-to ZIP]", d.zip);
    form.append("contact[Address type]", d.loc);
    form.append("contact[Forklift on site]", d.forklift);
    form.append("contact[Loading dock on site]", d.dock);
    form.append("contact[Product]", p.title || document.title);
    form.append("contact[SKU]", p.sku || "");
    form.append("contact[Product URL]", location.href);
    form.append("contact[Subject]", "Daytona freight quote — " + (p.title || "product"));
    form.append("contact[body]", body);

    btn.disabled = true; btn.textContent = "Sending...";
    fetch(ROOT.replace(/\/$/, "") + "/contact", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "text/html" },
      body: form.toString()
    }).then(function (r) {
      if (r.status >= 200 && r.status < 400) return true;
      throw new Error("status " + r.status);
    }).then(function () {
      _submitted = true;
      card.querySelector(".dtf-body").innerHTML =
        '<div class="dtf-ok"><b>Thanks, ' + (d.first || "") + '!</b><br>' +
        'Your freight-quote request is on its way to our team. We\'ll email your exact shipping cost shortly. ' +
        'Go ahead and add this lift to your cart — your Delivery selection is saved.</div>';
      applyGate();
      fitWidth(card.closest(".dtf-wrap"));
    }).catch(function () {
      btn.disabled = false; btn.textContent = "Email me my freight quote";
      errEl.style.display = "block";
      errEl.innerHTML = 'Sorry, that didn\'t go through. Please call us at <a href="tel:' + CFG.PHONE_TEL + '">' +
        CFG.PHONE_DISPLAY + '</a> and we\'ll quote it right away.';
    });
  }

  /* ---------- render / teardown ---------- */
  function ensureForm() {
    equalizeDelivery();
    var show = isDeliverySelected();
    var existing = $(".dtf-wrap");

    if (!show) { if (existing) existing.remove(); applyGate(); return; }
    if (_submitted && existing) { applyGate(); return; }   // keep success state

    var field = deliveryField();
    if (!field || !field.parentNode) return;
    if (existing && existing.previousElementSibling === field) { applyGate(); return; }
    if (existing) existing.remove();

    var wrap = document.createElement("div");
    wrap.className = "dtf-wrap";
    wrap.innerHTML = formHTML();
    field.parentNode.insertBefore(wrap, field.nextSibling);
    var card = $(".dtf-card", wrap);

    // segmented toggles
    $all(".dtf-seg", wrap).forEach(function (grp) {
      grp.addEventListener("click", function (e) {
        var b = e.target.closest(".dtf-pill");
        if (!b) return;
        $all(".dtf-pill", grp).forEach(function (x) { x.classList.remove("dtf-on"); });
        b.classList.add("dtf-on");
      });
    });

    $("#dtf-submit", wrap).addEventListener("click", function () {
      var errEl = $("#dtf-err", wrap); errEl.style.display = "none";
      var d = collect(wrap);
      var msg = validate(d);
      if (msg) { errEl.style.display = "block"; errEl.textContent = msg; return; }
      submitQuote(d, this, errEl, card);
    });
    $("#dtf-ordernow", wrap).addEventListener("change", applyGate);
    applyGate();
    fitWidth(wrap);
    setTimeout(function () { fitWidth(wrap); }, 300);
  }

  /* ---------- boot ---------- */
  function boot() {
    if (!/\/products\//.test(location.pathname)) return;
    var path = location.pathname.split("?")[0];
    fetch(path + ".js").then(function (r) { return r.json(); }).then(function (p) {
      if (!p || clean(p.vendor) !== CFG.VENDOR) return;   // Daytona Lifts only
      _product = { title: p.title, vendor: p.vendor, sku: (p.variants && p.variants[0] && p.variants[0].sku) || "" };
      injectCSS();
      document.addEventListener("click", interceptATC, true);
      document.addEventListener("change", function () { ensureForm(); }, true);
      window.addEventListener("resize", function () {
        var f = deliveryField(); if (f) f.removeAttribute("data-dtf-eq");
        equalizeDelivery();
        var w = $(".dtf-wrap"); if (w) fitWidth(w);
      });
      new MutationObserver(function () { ensureForm(); }).observe(document.body, { childList: true, subtree: true });
      ensureForm();
    }).catch(function () {});
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot)
    : boot();
})();